<template>
  <div class="suggestion-list" v-show="items && items.length > 0">
    <div
      class="suggestion-list__item"
      :class="{ 'is-selected': index === selectedIndex }"
      v-for="(item, index) in items"
      :key="index"
      @click="selectItem(index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import logClickEvent from '../../../utils/logClickEvent'
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
      required: true,
    },
    command: {
      type: Function,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  watch: {
    items() {
      this.selectedIndex = 0
    },
  },
  methods: {
    onKeyDown({ event }) {
      const suggestionListDom = document.querySelector('.suggestion-list')
      if (event.key === 'ArrowUp') {
        // 判断是否到顶
        if (this.selectedIndex - 1 > 0) {
          suggestionListDom.scrollTop -= 36
        }

        this.upHandler()
        return true
      }
      if (event.key === 'ArrowDown') {
        if (this.selectedIndex + 1 > 6 && this.selectedIndex + 1 <= this.items.length) {
          suggestionListDom.scrollTop += 36
        }
        this.downHandler()
        return true
      }
      if (event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()
        this.enterHandler()
        return true
      }
      return false
    },
    upHandler() {
      this.selectedIndex = (this.selectedIndex + this.items?.length - 1) % this.items?.length
    },
    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items?.length
    },
    enterHandler() {
      this.selectItem(this.selectedIndex)
    },
    selectItem(index) {
      logClickEvent('选择标签', this.query ? '选择匹配标签' : '选择默认标签')
      const item = this.items[index]
      if (item) {
        this.command({ id: item.name })
      }
    },
  },
}
</script>
<style scoped>
.suggestion-list {
  border: 1px solid rgba(00, 00, 00, 0.1);
  font-size: 0.8rem;
  /* font-weight: bold; */
  max-height: 260px;
  overflow-y: auto;
  background-color: var(--glassBg);
  color: var(--memoContentColor);
  border-radius: 5px;
  box-shadow: 0 2px 16px #dddddd;
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
}

/* 适配 tray */

@media (max-height: 400px) {
  .suggestion-list {
    max-height: 60vh !important;
  }
}

.suggestion-list::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
  border-radius: 10px;
}
.suggestion-list::-webkit-scrollbar-thumb {
  background: var(--scrollbarThumb);
}
.suggestion-list__no-results {
  padding: 8px 10px;
}
.suggestion-list__item {
  padding: 8px 10px;
  cursor: pointer;
}
.suggestion-list__item:last-child {
  margin-bottom: 0;
}
.suggestion-list__item.is-selected,
.suggestion-list__item:hover {
  background-color: var(--hoverBg);
}
.suggestion-list__item.is-empty {
  opacity: 0.5;
}
body.dark_mode .suggestion-list {
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.9) !important;
  border: 1px solid rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px) saturate(190%) contrast(70%) brightness(80%);
}

/* body.dark_mode .suggestion-list__item.is-selected,
body.dark_mode .suggestion-list__item:hover {
  color: #55bb8e;
  background-color: unset;
} */
</style>
